import Vue from "vue";
import VueMasonry from "vue-masonry-css";
import VueMoment from "vue-moment";
import moment from 'moment-timezone';
import "moment/locale/de";
import "moment/locale/es";
import "moment/locale/fr";
import "moment/locale/it";
import "moment/locale/pt";
import "moment/locale/th";
import "moment/locale/tr";

import Vue2Filters from "vue2-filters";
import App from "./App.vue";
import router from "./router";
import store from "./store";
import i18n from "./i18n";
import Redactor from "@/vendor/redactor/Redactor.vue";
import CloseIcon from "./assets/close-icon.vue";
import Spinner from "@/common/components/Spinner";
import axios from "axios";
import PortalVue from "portal-vue";

import "vue2-dropzone/dist/vue2Dropzone.min.css";

import "./assets/home-page-preview/nomadic-home-page.mjs";

axios.interceptors.response.use(
  (config) => {
    return config;
  },
  (error) => {
    if (
      error.response &&
      error.response.status === 403 &&
      error.response.data.error.must_sign_in
    ) {
      let redir;
      if (router.history.pending) {
        redir = router.history.pending.fullPath;
      } else {
        redir = location.pathname + location.search + location.hash;
      }
      sessionStorage.redir = redir;
      location.assign("/signin");
    }
    return Promise.reject(error);
  }
);

axios.defaults.xsrfCookieName = "CSRF-TOKEN";
axios.defaults.xsrfHeaderName = "X-CSRF-TOKEN";

let locale = /_LOCALE_=([^;]*)/.exec(document.cookie)
  ? /_LOCALE_=([^;]*)/.exec(document.cookie)[1]
  : null;

if (["en","de","es","fr","it","pt","th","tr"].includes(locale)) {
  moment.locale(locale);
} else {
  moment.locale("en");
}

Vue.use(PortalVue);
Vue.use(VueMasonry);
Vue.use(VueMoment, {
  moment
});
Vue.use(Vue2Filters);
Vue.component("Redactor", Redactor);
Vue.component("CloseIcon", CloseIcon);
Vue.component("Spinner", Spinner);

Vue.config.productionTip = false;

new Vue({
  router,
  store,
  i18n,
  render: (h) => h(App),
}).$mount("#app");

// store incoming parameters in session storage
(function() {
  let params = ["invitation", "discount", "referral_code", "redir", "affiliate", "homeJourney"];
  let qsParams = router.history.pending.query;
  params.forEach((param) => {
    if (qsParams.hasOwnProperty(param)) {
      sessionStorage[param] = qsParams[param];
    }
  });
})();
